import type { GitFileTreeWithContents, GitTreeItemWithContent } from '../models/git-worker.model';
import { traverseTree } from './traverse-tree';

export function treeToList(
  tree: GitFileTreeWithContents,
  options?: { onlyFilesWithContent?: boolean },
): GitTreeItemWithContent[] {
  const list: GitTreeItemWithContent[] = [];
  const { onlyFilesWithContent } = options || {};

  const callback: Parameters<typeof traverseTree>['1'] = (item) => {
    const isFile = item.type === 'file';
    const fileHasContent = !!item.content;
    if (isFile && (!onlyFilesWithContent || (onlyFilesWithContent && fileHasContent))) {
      list.push(item);
    }
  };

  Object.values(tree).forEach((item, level) => {
    callback(item, level || 0, tree);

    if (item.children) {
      traverseTree(item.children, callback, (level || 0) + 1);
    }
  });

  return list;
}
